import { useEffect, useRef, useState } from "react";
import "./index.css";

export default function Demo({ isEditing, demoData, onChange }) {
    const sectionRef = useRef(null);

    const [isInView, setIsInView] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const updateField = (field, value) => {
        onChange((prev) => ({
            ...(prev || {}),
            [field]: value
        }));
    };

    // 🎯 Extract YouTube ID
    const getYouTubeId = (url) => {
        if (!url) return null;
        const match = url.match(
            /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/
        );
        return match ? match[1] : null;
    };

    const youtubeId = getYouTubeId(demoData.youtubeUrl);

    const thumbnail = youtubeId
        ? `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`
        : null;

    // 👀 Scroll detection
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsInView(true);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div className={`demo-card ${isInView ? "fade-in" : ""}`}>

            {/* LEFT */}
            <div className="demo-content">
                {isEditing ? (
                    <>
                        <input className="demo-input small"
                            value={demoData.eyebrow || ""}
                            onChange={(e) => updateField("eyebrow", e.target.value)} />

                        <textarea className="demo-input title"
                            value={demoData.title || ""}
                            onChange={(e) => updateField("title", e.target.value)} />

                        <textarea className="demo-input"
                            value={demoData.description || ""}
                            onChange={(e) => updateField("description", e.target.value)} />

                        <input className="demo-input link"
                            value={demoData.linkText || ""}
                            onChange={(e) => updateField("linkText", e.target.value)} />

                        <input
                            className="demo-input"
                            placeholder="Paste YouTube URL"
                            value={demoData.youtubeUrl || ""}
                            onChange={(e) => updateField("youtubeUrl", e.target.value)}
                        />
                    </>
                ) : (
                    <>
                        <h5 className="demo-eyebrow">{demoData.eyebrow}</h5>
                        <h2 className="demo-heading">{demoData.title}</h2>
                        <p className="demo-description">{demoData.description}</p>
                        <a href="#" className="demo-link">{demoData.linkText}</a>
                    </>
                )}
            </div>

            {/* RIGHT */}
            <div className="demo-video-wrapper" ref={sectionRef}>

                {!youtubeId ? (
                    isEditing && (
                        <div className="demo-empty-upload">
                            Paste YouTube URL to show video
                        </div>
                    )
                ) : (
                    <div className="video-premium-container">

                        {/* 🎬 THUMBNAIL (before load) */}
                        {!isLoaded && (
                            <div className="video-thumbnail">
                                <img src={thumbnail} alt="" />
                                <div className="play-overlay" />
                            </div>
                        )}

                        {/* 🎥 IFRAME */}
                        {isInView && (
                            <iframe
                                className={`youtube-iframe ${isLoaded ? "show" : ""}`}
                                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&controls=1&rel=0&playsinline=1`}
                                title="YouTube video"
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                                onLoad={() => {
                                    setTimeout(() => setIsLoaded(true), 100);
                                }}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}